import React, { useEffect, useState } from "react"
import { Carousel } from "react-responsive-carousel"
import { Trans, useTranslation } from "react-i18next"
import classNames from "classnames"
import { followersCount } from "../../Utils/Converter"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faCheck,
  faCheckCircle,
  faImages,
  faQuestionCircle,
  faStar,
} from "@fortawesome/free-solid-svg-icons"
import { returnSelectedItems } from "../../Utils/TypeList"
import { faAddressCard, faMap } from "@fortawesome/free-regular-svg-icons"
import { Chart } from "react-google-charts"
import { useDispatch, useSelector } from "react-redux"
import { getCountry } from "../../Utils/Countries"
import KOL from "../../../src/Model/KOL"
import { IG_USER_DATA } from "../../Enum/LOGIN_PAGE_TYPE"
import { createChatroom } from "../../HelpingFunction/Chatroom/chatroomDBHelper"
import { isAuth, returnIdTokenResult } from "../../Utils/FirebaseUtils"
import { useHistory, useParams } from "react-router-dom"
import { SUPPORTED_REDUX_FUNCTIONS } from "../../Redux/SUPPORTED_REDUX_FUNCTION"
import { CHATROOM_PAGE_TYPE, ROLE } from "../../Enum/APP_TYPE"
import {
  getRole,
  getUserLang,
  returnThumbnailUrl,
} from "../../Utils/utiltyHelper"

import ProfileLinksShareBox from "../../Component/ProfileLinksShareBox"

import { SUPPORTED_MODAL_TYPE } from "../../Utils/ModalType"

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import blurImg from "../../../src/Assets/qqq.png"
import { t } from "i18next"
import { getAuthUID, getQuery } from "../../Utils/QueryHelper"

const AboutKOL = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()

  const params = useParams<{
    lang: "hk" | "en"
    id: string
    type: string
  }>()

  const paramList = useSelector((state: any) => {
    return state.QueryManager.params
  })

  const auth = useSelector((state: any) => {
    return state.firebase.auth
  })
  const profile: KOL = useSelector((state: any) => {
    return state.KOLInfoManager.kolInfo
  })
  const igKOLData: IG_USER_DATA = useSelector((state: any) => {
    return state.KOLInfoManager.igKOLData
  })

  const [country, setCountry] = useState<{
    value: string
    label: string
    alpha_code?: string
  }>()
  const [role, setRole] = useState<ROLE | "">()
  const [creatingChatroom, setIsCreatingChatroom] = useState<boolean>(false)

  const setViewImageModal = (state: any) => {
    dispatch({
      type: SUPPORTED_REDUX_FUNCTIONS.TOGGLE_MODAL,
      typeOfModal: SUPPORTED_MODAL_TYPE.VIEW_IMAGE_MODAL,
      returnFn: state.returnFn,
      metaData: state.metaData,
    })
  }
  const setContractType = () => {
    dispatch({
      type: SUPPORTED_REDUX_FUNCTIONS.SET_CHATROOM_PAGE_TYPE,
      data: CHATROOM_PAGE_TYPE.PROFILE,
    })
  }

  const resetAllChatrooms = () => {
    dispatch({
      type: SUPPORTED_REDUX_FUNCTIONS.RESET_CHATROOMS,
    })
  }

  useEffect(() => {
    const tempCountry = getCountry(profile.nationality)
    setCountry(tempCountry)
  }, [profile])

  useEffect(() => {
    if (isAuth(auth)) {
      const getRoleFn = async () => {
        const role = await getRole(getQuery(paramList, "viewAs"))
        setRole(role)
      }
      getRoleFn()
    }
  }, [auth])

  const getCustomerUserName = (): Promise<string> => {
    return new Promise(async (resolve, reject) => {
      const getState = await returnIdTokenResult()
      if (getState.success) {
        return resolve(
          typeof getState.token.userName !== "undefined"
            ? getState.token.userName
            : ""
        )
      }
      return resolve("")
    })
  }

  const submitRequest = async () => {
    if (isAuth(auth)) {
      resetAllChatrooms()
      setIsCreatingChatroom(true)
      const customerName = await getCustomerUserName()
      createChatroom(auth.uid, profile.id, profile.userName, customerName).then(
        (result) => {
          if (result.success) {
            setIsCreatingChatroom(false)
            history.push({
              pathname: "/" + getUserLang() + "/c",
              search:
                "?" + new URLSearchParams({ chatroomID: result.chatroomID }),
            })
            setContractType()
          }
        }
      )
    } else {
      history.push("/" + getUserLang() + "/login")
    }
  }
  const redirectPathToEditProfile = () => {
    history.push({
      pathname: "/" + getUserLang() + "/p/" + profile.id + "/edit",
    })
  }

  const canShareLinkTree =
    (getAuthUID(paramList) === params.id ||
      getAuthUID(paramList) === profile.id) &&
    profile.userName

  return (
    <>
      <div className="w-full pt-6 lg:p-4 p-2">
        {/* KOL Information*/}
        <section className="relative w-full mt-14 mb-4 bg-white shadow-md border border-gray-100 rounded-xl pt-20 pb-4 px-4 ">
          <div className="absolute -top-14 right-0.5 mx-auto inline-block w-full ">
            <div className="w-24 h-24 xl:w-32 xl:h-32 rounded-full mx-auto text-center">
              <img
                className="object-cover w-24 h-24 xl:w-32 xl:h-32 rounded-full"
                alt={profile.userName + "avatar image"}
                src={
                  profile.avatarUrl
                    ? profile.avatarUrl
                    : "https://look4kol.com/logo.png"
                }
              />
            </div>
          </div>

          {/*  KOL username and score*/}
          <div className="text-center mx-auto">
            <h1 className="hidden">
              {profile.userName} - {igKOLData.numOfFollowers} Followers -
              Look4KOL
            </h1>
            <div className="inline-block font-semibold text-lg lg:text-2xl p-0 m-0">
              {profile.userName}
            </div>
            <span
              className="inline-block cursor-pointer my-auto"
              onClick={() =>
                window.open("https://instagram.com/" + profile.userName)
              }>
              <svg
                className="svg-inline--fa fa-instagram  w-5 h-5 ml-2"
                aria-hidden="true"
                focusable="false"
                data-prefix="fab"
                data-icon="instagram"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                data-fa-i2svg="">
                <path
                  fill="currentColor"
                  d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>
              </svg>
            </span>

            {profile.isVerified ? (
              <div
                className="tooltip cursor-pointer hover:underline text-left text-sm mx-auto text-green-700 w-20 my-2 block "
                data-tip={t("Warning.kol-verified")}>
                <FontAwesomeIcon icon={faCheck} className="mr-1" />
                <Trans>KOLProfile.verified</Trans>
              </div>
            ) : (
              <div
                className="tooltip cursor-pointer hover:underline text-left text-sm mx-auto text-gray-500 w-20 my-2 block "
                data-tip={t("Warning.kol-not-verified")}>
                <FontAwesomeIcon icon={faQuestionCircle} className="mr-1" />
                <Trans>KOLProfile.not-verified</Trans>
              </div>
            )}

            <div className="text-left text-sm mx-auto w-20 my-2 ml-auto block ">
              <FontAwesomeIcon
                icon={faStar}
                className="mr-1 text-red-default"
              />
              {profile.score} / 5
            </div>
          </div>

          {/*  KOL follower count and num of post */}
          <div className="grid grid-cols-3 col-span-3 my-4">
            <div className={"text-center my-auto"}>
              <p className={"text-lg font-semibold"}>
                {igKOLData.numOfPosts ? igKOLData.numOfPosts : 0}
              </p>
              <span className="text-md text-gray-500 font-normal">
                <Trans>SignUp.posts</Trans>
              </span>
            </div>
            <div className={"text-center  my-auto"}>
              <p className={"text-lg font-semibold"}>
                {igKOLData.numOfFollowers
                  ? followersCount(igKOLData.numOfFollowers)
                  : 0}
              </p>
              <span className="text-md text-gray-500 font-normal">
                <Trans>SignUp.followers</Trans>
              </span>
            </div>
            <div className={"text-center  my-auto"}>
              <p className={"text-lg font-semibold"}>
                {igKOLData.numOfFollowing ? igKOLData.numOfFollowing : 0}
              </p>
              <span className="text-md text-gray-500 font-normal">
                <Trans>SignUp.following</Trans>
              </span>
            </div>
          </div>

          {/* KOL category tag*/}
          <div className="overflow-y-hidden mt-8 mb-4 w-full whitespace-nowrap noScrollBar relative">
            {Array.isArray(profile.type) &&
              returnSelectedItems(profile.type).map((t) => {
                return (
                  <button
                    key={t.value}
                    className="bg-white hover:bg-gray-50 px-2 py-2 rounded-full text-xs rounded-lg border border-gray-200 text-red-default mr-2">
                    {t.label}
                  </button>
                )
              })}
          </div>

          {/* KOL action button (contact kol or edit kol)*/}
          <div className="w-full">
            {role === ROLE.KOL && getAuthUID(paramList) === profile.id ? (
              <button
                onClick={() => redirectPathToEditProfile()}
                className="btn btn-warning w-full mt-2 h-12 rounded-xl normal-case ">
                <Trans>Warning.edit-profile</Trans>
              </button>
            ) : (
              <button
                onClick={() => submitRequest()}
                disabled={creatingChatroom}
                className={classNames(
                  "btn btn-primary w-full mt-2 h-12 rounded-xl normal-case ",
                  {
                    loading: creatingChatroom,
                  }
                )}>
                <Trans>KOLProfile.contact-kol</Trans>
              </button>
            )}
          </div>

          <div
            className={classNames({
              "absolute right-0 h-12 w-8 md:hidden mb-2": profile.type.length,
            })}
            style={{ bottom: "65px" }}>
            <img className="h-8" src={blurImg} alt={"blur image placeholder"} />
          </div>
        </section>

        {isAuth(auth) && canShareLinkTree && (
          <section className="w-full bg-white rounded-xl shadow p-4 xl:p-6 h-auto my-4">
            <ProfileLinksShareBox userName={profile.userName} />
          </section>
        )}

        {/* KOL description*/}
        <section className="w-full bg-white rounded-xl shadow p-4 xl:p-6 h-auto my-4">
          <div>
            <FontAwesomeIcon
              className="text-md mr-2 text-gray-500"
              icon={faAddressCard}
            />
            <h2 className="inline-block text-md text-gray-800 ">
              <Trans>KOLProfile.kol-description</Trans>
            </h2>
          </div>
          <p className="mt-4 text-sm text-gray-500 max-h-40 h-auto overflow-x-hidden overflow-y-auto break-words	">
            {profile.description}
          </p>
          {profile.metaDesc && <p className="hidden">{profile.metaDesc}</p>}
        </section>

        {/* KOL Cover Image*/}
        <section className="w-full bg-white rounded-xl shadow p-4 xl:p-6 h-auto my-4">
          <div>
            <FontAwesomeIcon
              className="text-md mr-2 text-gray-500"
              icon={faImages}
            />
            <p className="inline-block text-md text-gray-800 ">
              <Trans>KOLProfile.kol-cover-image</Trans>
            </p>
          </div>

          <Carousel
            preventMovementUntilSwipeScrollTolerance={true}
            swipeScrollTolerance={50}
            className="w-full rounded-xl mt-4 mb-4 bg-white  "
            showStatus={false}
            showThumbs={false}>
            {profile.coverImages
              .filter((img) => img !== "")
              .map((e: string | undefined, index: number) => {
                if (e !== "") {
                  return (
                    <div
                      onClick={() =>
                        setViewImageModal({
                          returnFn: null,
                          metaData: {
                            imageUrl: profile.coverImages,
                          },
                        })
                      }
                      key={"lk" + profile.id + index}
                      className="w-full rounded-xl cursor-pointer">
                      <img
                        alt={profile.userName + " cover image"}
                        className="rounded-xl object-cover lazyload h-72  aspect-square"
                        src={returnThumbnailUrl(e as string)}
                      />
                    </div>
                  )
                }
                return <div></div>
              })}
          </Carousel>
        </section>

        {/* KOL Map Location*/}
        <section
          className={"w-full bg-white rounded-xl shadow p-4 xl:p-6 h-auto"}>
          <div>
            <FontAwesomeIcon
              className="text-md mr-2 text-gray-500"
              icon={faMap}
            />
            <p className="inline-block text-md text-gray-800 ">
              <Trans>KOLProfile.location</Trans>
            </p>
            <p className="text-xs text-gray-400 my-2">
              <Trans>KOLProfile.kol-location</Trans>
              <span className="text-primary">{country?.label}</span>
            </p>
          </div>
          <div>
            <Chart
              chartType={"GeoChart"}
              loader={<div>Loading Chart</div>}
              data={[["Country"], [country?.label]]}
              options={{ region: country?.alpha_code }}
              // For tests
              rootProps={{ "data-testid": "2" }}
            />
          </div>
        </section>
      </div>
    </>
  )
}

export default AboutKOL
